import http from "./http.js";

async function getManager(id) {
  try {
    const response = await http.get(`managers/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      salesPlan: response.data.salesPlan,
      email: response.data.email,
      clients: response.data.clients.map(c => {
        return {
          id: c.id,
          title: c.title,
        };
      }),
    };
  } catch (err) {
    throw err;
  }
}

async function updateManager(id, manager) {
  try {
    const response = await http.put(`managers/${id}`, manager);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createManager(manager) {
  try {
    const response = await http.post("managers", manager);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getManagers(page = 1, rowsPerPage = 9, search = "", filter = "") {
  try {
    const response = await http.get(
      `managers?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectManager(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get(
      "managers/references",
      {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getManager, updateManager, createManager, selectManager, getManagers };
